import { useEffect, useState } from 'react';
import { FaAngleRight } from 'react-icons/fa';
import { MdCalendarToday } from 'react-icons/md';
import CircleIcon from 'components/CircleIcon';
import SectionLabel from 'components/typography/SectionLabel';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';
import { getPluralForm } from 'shared/helpers/common';
import BookingsItem from './BookingsItem';
import ViewMoreDetails from './ViewMoreDetails';

export default function Bookings({ bookings = [] }) {
  const [overviewList, setOverviewList] = useState([]);

  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();

  useEffect(() => {
    setOverviewList(bookings?.slice?.(0, 2) || []);
  }, [bookings]);

  return (
    <>
      <div className="mt-[40px] flex justify-between items-center">
        <div className="flex items-start">
          <CircleIcon className="mt-1" iconClassName="text-xl">
            <MdCalendarToday style={{ fill: primaryColour }} />
          </CircleIcon>
          <SectionLabel
            label={`Your ${getPluralForm('booking', bookings?.length)}`}
            className="ml-[20px] mt-1"
          />
        </div>
        {bookings?.length > 2 && (
          <ViewMoreDetails
            className="hidden lg:flex"
            label="View all bookings"
            icon={<FaAngleRight />}
            url={ROUTES_SELF_SERVICE.BOOKINGS}
          />
        )}
      </div>
      {overviewList.map((booking, index) => (
        <BookingsItem key={booking?.id || index} booking={booking} />
      ))}
      {bookings?.length === 0 && (
        <div className="mt-10 text-center text-gray-600">
          <p className="text-lg font-medium">
            Sorry, our bookings system appears to be down at this time.
          </p>
          <p className="mt-2 mb-10">
            Please contact customer support if this issue persists.
          </p>
        </div>
      )}
      {bookings?.length > 2 && (
        <ViewMoreDetails
          className="mt-7 lg:hidden"
          label="View all bookings"
          icon={<FaAngleRight />}
          url={ROUTES_SELF_SERVICE.BOOKINGS}
          isSmallScreen
        />
      )}
    </>
  );
}
